
/**
 * Module dependencies.
 */

import { fetchPage } from 'src/api/app/pages/fetch-page';
import { getApiPageSlugByLocale } from 'src/core/utils/routes';
import Legal, { PageProps } from 'src/components/legal';
import React, { ReactElement } from 'react';

/**
 * `Props` type.
 */

type Props = {
  data: PageProps,
  slug: string
};

/**
 * `CookiesPolicy` page.
 */

const CookiesPolicy = (props: Props): ReactElement => (
  <Legal
    {...props}
    routeName={'cookiesPolicy'}
  />
);

/**
 * Export `getServerSideProps`.
 */

export async function getServerSideProps({ locale, query }) {
  const slug = getApiPageSlugByLocale('cookiesPolicy', locale);
  const pageData = await fetchPage({
    hasPreview: query?.preview,
    locale,
    slug
  });

  if (!pageData) {
    return {
      notFound: true
    };
  }

  return {
    props: {
      data: pageData,
      slug
    }
  };
}

/**
 * Export `CookiesPolicy` page.
 */

export default CookiesPolicy;
